import React,{useEffect,useState,Fragment} from 'react';
import {useHistory} from 'react-router-dom';
import {motion} from 'framer-motion';
import styled from 'styled-components';
import Panel from '../components/Panel';
import Content from '../components/Content';
import Expanded from '../components/Expanded';
import Progress from '../components/Progress';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import HomeIcon from '../assets/img/home-icon.svg';


const Question3 = (props) => {

    // const [q3,getQ3] = useState(50);
    const [isAnswered,setIsAnswered] = useState(false);
    const history = useHistory();
    const [isExtraOpen, setIsExtraOpen] = useState(false);

    const getInput = e => {
        const t = e.currentTarget.value;
        props.getQ3(t);
    }

    const checkInput = e => {
        setIsAnswered(true)
        e.preventDefault();
    }

    return(
        <QuestionPage className="yellow">
            <Panel className="yellow" setBG="bp5">
                <div className="process-title">business process #3</div>
                </Panel>
            {!isAnswered ?
                    <Content preAns isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1 className="main-q">care center efficiency</h1>
                    <h2 className="question-title">What is your first contact resolution (FCR) rate?</h2>
                    <form onSubmit={checkInput} action="">
                        <br></br>    
                        <br></br>      
                        <input className="default-slider seconds" required onChange={getInput} type="range" min="1" max="100" />  <LivePerc>{props.q3 == undefined || null ? '50' : props.q3} %</LivePerc>
                        <br></br>
                        <CalculateButton />
                    </form>
                </Content>

                :
                <Content preAns={false} isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    {props.q3 > 90 ?
                    <Fragment>
                        <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                        <h1 className="main-q">care center efficiency</h1>
                        <div className="determined-benchmark">You are <span>ahead</span> of the industry benchmark</div>
                        <TextInfo>
                            <div>
                                <p>Across the industry, we have found that the typical FCR rate is approximately 90%.</p>
                                <p>While that sounds good, it’s not good enough. Your customers want their issues resolved upon first contact.</p>
                                <p>And they’re not the only ones. So do you, because the faster issues are resolved, the lower your cost of care.</p>
                            </div>
                        </TextInfo>
                        </motion.div>  
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                        <p>With our integration and automation platforms, we help your agents access relevant and required data faster to resolve issues the first time and avoid repeat calls.</p>
                        <p>Moreover, our solutions can prevent calls altogether by:</p>
                        <ul>
                            <li><b>Performing data reconciliation</b>, such as aligning out-of-sync data across multiple databases to ensure correct shipping and billing of mobile devices and services</li>
                            <li><b>Providing automated replies to email requests</b>, such as resend bill and send contract information</li>
                            <li><b>Reconnecting</b> customer services after issue resolution</li>
                            <li><b>Forwarding requests</b> to specific tools, e.g. request for a specific number or blocking a line</li>
                            <li><b>Invoking self-healing</b> for IT system outage and fallouts</li>
                        </ul>
                        <NextPage onClick={()=>{history.push('/question4')}}>next question <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>        
                        
                    </Fragment>

                    : props.q3 == 90 ?
                    <Fragment>
                        <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                        <h1 className="main-q">care center efficiency</h1>
                        <div className="determined-benchmark">You are <span>exactly</span> in line with the industry benchmark</div>
                        <TextInfo>
                            <div>
                                <p>Across the industry, we have found that the typical FCR rate is approximately 90%.</p>
                                <p>While that sounds good, it’s not good enough. Your customers want their issues resolved upon first contact.</p>
                                <p>And they’re not the only ones. So do you, because the faster issues are resolved, the lower your cost of care.</p>
                            </div>
                        </TextInfo>
                        </motion.div>  
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                    <p>With our integration and automation platforms, we help your agents access relevant and required data faster to resolve issues the first time and avoid repeat calls.</p>
                        <p>Moreover, our solutions can prevent calls altogether by:</p>
                        <ul>
                            <li><b>Performing data reconciliation</b>, such as aligning out-of-sync data across multiple databases to ensure correct shipping and billing of mobile devices and services</li>
                            <li><b>Providing automated replies to email requests</b>, such as resend bill and send contract information</li>
                            <li><b>Reconnecting</b> customer services after issue resolution</li>
                            <li><b>Forwarding requests</b> to specific tools, e.g. request for a specific number or blocking a line</li>
                            <li><b>Invoking self-healing</b> for IT system outage and fallouts</li>
                        </ul>
                        <NextPage onClick={()=>{history.push('/question4')}}>next question <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>                
                    </Fragment>
                    : props.q3 < 90 ?
                    <Fragment>
                    <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                    <h1 className="main-q">care center efficiency</h1>
                        <div className="determined-benchmark">You are <span>behind</span> the industry benchmark</div>
                        <TextInfo>
                            <div>
                                <p>Across the industry, we have found that the typical FCR rate is approximately 90%.</p>
                                <p>While that sounds good, it’s not good enough. Your customers want their issues resolved upon first contact.</p>
                                <p>And they’re not the only ones. So do you, because the faster issues are resolved, the lower your cost of care.</p>
                            </div>
                        </TextInfo>
                        </motion.div>  
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                    <p>With our integration and automation platforms, we help your agents access relevant and required data faster to resolve issues the first time and avoid repeat calls.</p>
                        <p>Moreover, our solutions can prevent calls altogether by:</p>
                        <ul>
                            <li><b>Performing data reconciliation</b>, such as aligning out-of-sync data across multiple databases to ensure correct shipping and billing of mobile devices and services</li>
                            <li><b>Providing automated replies to email requests</b>, such as resend bill and send contract information</li>
                            <li><b>Reconnecting</b> customer services after issue resolution</li>
                            <li><b>Forwarding requests</b> to specific tools, e.g. request for a specific number or blocking a line</li>
                            <li><b>Invoking self-healing</b> for IT system outage and fallouts</li>
                        </ul>
                        <NextPage onClick={()=>{history.push('/question4')}}>next question <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>                
                    </Fragment>
                    : 
                    <Fragment></Fragment>
                    }
                </Content>
            }
           
           <Progress prog={60} />

        </QuestionPage>
    )
}

const QuestionPage = styled(motion.div)`
    width: 100%;
    height: 100%;
    overflow-x: hidden !important;
    display: flex;

    @media (max-width: 1060px) {
        flex-direction: column;
    }
`;

const IndustryBenchmark = styled.h3`
    font-family: 'MarkPro-ExtraLight';
    margin-bottom: 20px;
`;

const TextInfo = styled.div`
    display: flex;

    div{
        flex: 1;
        margin-right: 50px;
    }

`;


const NextPage = styled.div`
   font-family: 'MarkPro-Bold';
    color: #fff;
    background: #EAB330;
    text-align: center;
    position: fixed;
    bottom: 60px;
    right: 0;
    font-size: 1.5em;
    padding: 15px;
    cursor: pointer;
    z-index:1000;

    @media (max-width: 1060px) {
        display: block;
        position: static;
        margin-top: 30px;
    }

`;

const NextArrow = styled(FontAwesomeIcon)`
    margin-left: 10px;
`;



const CalculateButton = styled.input.attrs({ 
    type: 'submit',
    value: 'submit'
  })`
    background: #333147;
    color: #fff;
    cursor: pointer;
    margin-bottom: 0;
    border-color: transparent;
    box-shadow: 0px;
    outline: none;
    text-align: center;
    font-family: 'MarkPro-Bold';
    padding: 10px;
    font-size: 1.3em;
    width: 130px;
    margin-top: 30px;
  `


const LivePerc = styled.span`
    font-family: 'MarkPro-Bold';
    font-size: 2em;
    margin-left: 30px;

    @media (max-width: 1060px) {
        margin-left: 0;
    }
`;


const DummyContainer = styled(motion.div)`
    display: contents;
`;

const HomeButton = styled.div`
    display: block;
    width: 70px; 
    height: 70px;
    border-radius: 100px;
    position: absolute;
    top: 20px;
    left: 20px;
    background: url(${HomeIcon}) no-repeat center center;
    background-size: 60%;
    background-color: #333147;
    cursor: pointer;

    @media (max-width: 1060px) {
        width: 62px;
        height: 62px;
    }
`;

export default Question3;